import { render, staticRenderFns } from "./teipForm.vue?vue&type=template&id=6fe3056a&"
import script from "./teipForm.vue?vue&type=script&lang=ts&"
export * from "./teipForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports